import React from "react";
import EditableText from "./EditableText";
import { trustInfo } from "../mock";

const Hero = () => {
  return (
    <section id="home" className="relative w-full bg-[#dad7c9] overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-14 md:py-20 grid grid-cols-1 md:grid-cols-2 gap-10 items-start">
        {/* Parents photo (real image) — container matches image aspect to avoid empty grey areas */}
        <div className="relative flex justify-center md:justify-start">
          <div className="relative w-full max-w-[520px] rounded-sm overflow-hidden shadow-2xl ring-1 ring-black/20 bg-[#3b3025]">
            <img
              src="/parents.jpg"
              alt="Sri P. Rama Rao and Smt. Sharada Rama Rao"
              className="block w-full h-auto"
              draggable={false}
            />
            <div className="absolute inset-0 pointer-events-none"
                 style={{ boxShadow: "inset 0 0 80px rgba(0,0,0,0.35)" }} />
          </div>
        </div>

        {/* Right side: new logo + text */}
        <div className="flex flex-col items-center md:items-start text-center md:text-left">
          <img
            src="/sr-logo.png"
            alt="Sharada Rama Rao Trust — Join Hands, Spread Kindness"
            className="w-[220px] md:w-[260px] h-auto drop-shadow-md"
            draggable={false}
          />
          <EditableText id="hero.tagline" as="p" className="mt-6 text-[#4a2a2e] text-lg md:text-xl font-medium tracking-wide">
            {trustInfo.tagline}
          </EditableText>
          <EditableText
            id="hero.title"
            as="h1"
            multiline
            className="mt-3 text-[#6b8e23] font-extrabold leading-[1.05] whitespace-pre-line"
            style={{ fontFamily: "'Quicksand', system-ui, sans-serif", fontSize: "clamp(2.4rem, 5.5vw, 4rem)" }}
          >
            {"Sharada Rama Rao\nTrust\u00ae"}
          </EditableText>
          <p className="mt-6 text-[#222] text-base md:text-lg font-semibold">
            <EditableText id="hero.reg" as="span">{`Registration No. ${trustInfo.registrationNo}`}</EditableText>
          </p>
          <EditableText id="hero.subtitle" as="p"
             className="mt-8 italic text-[#c47750] text-lg md:text-xl"
             style={{ fontFamily: "'Caveat', 'Quicksand', cursive" }}>
            {trustInfo.subtitle}
          </EditableText>
        </div>
      </div>
    </section>
  );
};

export default Hero;
